module.exports = __webpack_public_path__ + "img/6_52.1b7a9d47.png";